export class AnnotationsMapper {
    /**
     * Convert a list of annotations to a map per page
     * @param {Array} data
     * @returns {Object}
     */
    static annotationsArrayToAnnotationsPageMap(data) {
        const map = {};
        if (isArray(data)) {
            data.forEach(annotations => (map[annotations.page + 1] = annotations.data));
        }
        return map;
        function isArray(data) {
            return data && typeof data === 'object' && typeof data.length === 'number';
        }
    }
}
//# sourceMappingURL=AnnotationsMapper.js.map